export default "__VITE_ASSET__BVh2T0PT__"